import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';

export const padding1 = css`
  padding: 0.1rem !important;
`;

export const borderRadius1 = css`
  border-radius: 0.1rem !important;
`;

export const blurBackgroundBorder = css`
  border-color: rgba(102, 102, 102, 0.6);
`;

export const grayBorder = css`
  border-color: #333 !important;
`;

export const opacity20 = css`
  opacity: 0.2 !important;
`;

export const fontSize13 = css`
  font-size: 1.3rem !important;
`;

export const lineHeight19 = css`
  line-height: 1.9rem !important;
`;

export const blurBackground = css`
  background: var(--gray-850) !important;
  ${blurBackgroundBorder};
`;

export const translucentColor = css`
  color: var(--gray-850) !important;
`;

export const selectedBlurBackground = css`
  background: rgba(255, 255, 255, 0.1);
`;

export const hoverBlurBackgroundLight = css`
  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

export const hoverBlurBackground = css`
  &:hover {
    background: rgba(255, 255, 255, 0.1) !important;
  }
`;

export const hoverBlurBackgroundWhite = css`
  &:hover {
    background: #f2f2f2 !important;
  }
`;

export const w500 = css`
  width: 500px;
`;

export const classInfoWithTimer = css`
  width: 32.6rem;
`;

export const classInfoPopover = css`
  @media ${BREAKPOINT_QUERIES.Desktop} {
    width: 38.6rem;
  }
  @media ${BREAKPOINT_QUERIES.Tablet} {
    width: 38.6rem;
  }
`;

export const red400BorderColor = css`
  border-color: #ff5b52;
`;

export const red400TextColor = css`
  color: #ff5b52;
`;

export const red400Background = css`
  background: #ff5b52 !important;
`;

export const py28 = css`
  padding-top: 11.2rem !important;
  padding-bottom: 11.2rem !important;
`;

export const floatingStreamsContainer = css`
  background: linear-gradient(
    270deg,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.297406) 6.67%,
    rgba(0, 0, 0, 0.289347) 13.33%,
    rgba(0, 0, 0, 0.275502) 20%,
    rgba(0, 0, 0, 0.255777) 26.67%,
    rgba(0, 0, 0, 0.230468) 33.33%,
    rgba(0, 0, 0, 0.200435) 40%,
    rgba(0, 0, 0, 0.167193) 46.67%,
    rgba(0, 0, 0, 0.132807) 53.33%,
    rgba(0, 0, 0, 0.0995652) 60%,
    rgba(0, 0, 0, 0.0695324) 66.67%,
    rgba(0, 0, 0, 0.0442234) 73.33%,
    rgba(0, 0, 0, 0.024498) 80%,
    rgba(0, 0, 0, 0.010653) 86.67%,
    rgba(0, 0, 0, 0.00259416) 93.33%,
    rgba(0, 0, 0, 0) 100%
  );
`;

export const streamBackground = css`
  background-color: #161616;
`;

export const streamBorderColor = css`
  border-color: #161616 !important;
`;

export const muteBorderColor = css`
  border-color: #ff5b52 !important;
`;

export const speakingBorderColor = css`
  border-color: #1cfda2 !important;
`;

export const border3 = css`
  border-width: 0.3rem;
`;

export const border6 = css`
  border-width: 0.6rem;
`;

export const borderRadius6 = css`
  border-radius: 0.6rem !important;
`;

export const borderRadius12 = css`
  border-radius: 1.2rem !important;
`;

export const borderRadius16 = css`
  border-radius: 1.6rem !important;
`;

export const borderRadius24 = css`
  border-radius: 2.4rem !important;
`;

export const blackBackground = css`
  background-color: var(--black);
`;

export const gray200Background = css`
  background-color: var(--gray-200);
`;

export const gray600Background = css`
  background-color: var(--gray-600);
`;

export const gray900Background = css`
  background-color: var(--gray-900);
`;

export const gray700Background = css`
  background-color: var(--gray-700);
`;

export const snackBarWrapper = css`
  box-shadow: 0rem 0rem 0.2rem 0rem rgba(0, 0, 0, 0.12);
  min-width: 26rem;
`;

export const dividerBorder = css`
  border-color: rgba(102, 102, 102, 0.6);
`;

export const snackBarPosition = (addDrawerWidthOffset: boolean, userIdle: boolean) => css`
  top: 8rem !important;
  right: ${addDrawerWidthOffset ? '37rem' : '0.8rem'} !important;
  transition: right 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
`;

export const iconStyles = css`
  @media ${BREAKPOINT_QUERIES.Mobile} {
    width: 3.2rem !important;
    height: 3.2rem !important;
  }
  @media ${BREAKPOINT_QUERIES.Desktop} {
    width: 3.6rem !important;
    height: 3.6rem !important;
  }
  @media ${BREAKPOINT_QUERIES.Tablet} {
    width: 3.6rem !important;
    height: 3.6rem !important;
  }
`;

const commonControlStyles = css`
  border-radius: 16px;

  :hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const iconButtonStyles = css`
  width: 4.8rem !important;
  height: 4.8rem !important;
  ${commonControlStyles};
`;

export const iconButtonBackgroundStyles = css`
  background: rgba(255, 255, 255, 0.1) !important;
`;

export const smallIconButtonStyles = css`
  width: 4rem !important;
  height: 4rem !important;
  ${commonControlStyles};
`;

export const iconRaiseHand = css`
  width: 4.8rem !important;
  height: 4.8rem !important;
`;

export const smallIconRaiseHand = css`
  width: 4rem !important;
  height: 4rem !important;
`;

export const listIconsBackground = css`
  background-color: rgba(63, 63, 63, 0.6);
  border: none !important;
`;

export const backdropBlur60 = css`
  backdrop-filter: blur(60px);
`;
